(ns app.front.ui.chevron
  (:require [app.front.util :as futil]
            [core.front.carbon :as cc]
            [core.front.icons :as i]
            [schema-tools.core :as st]))

(defn chevron
  "A component for displaying the open/close status of sections or other elements.
   Animates with a rotating motion when changing state.

   Required properties:
   `:tr`, `:expanded?`, `:size`
   Optional properties
   `:side`     (either `:left` or `:right`, defaults to right)
   `:icon`     (default `i/chevron-small-right`)

   Passes on rest of the opts as `cc/IconOptions`"
  [{:keys [tr expanded? side class size icon] :or {size 16} :as opts}]
  (let [side    (cond
                  (= side :left) "chevron--left"
                  :else          "chevron--right")
        state   (if expanded?
                  "chevron--expanded"
                  "chevron--collapsed")
        classes (futil/cs "chevron" "relative" class side state)]
    (cc/icon (-> {:icon        (or icon i/chevron-small-right)
                  :description (if expanded?
                                 (tr [:close])
                                 (tr [:open]))
                  :fill        "currentcolor"
                  :class-name  classes
                  :view-box    "0 0 18 18"
                  :height      (str size)
                  :width       (str size)}
                 (merge opts)
                 (st/select-schema cc/IconOptions)))))
